import { injectable } from 'tsyringe'
import { MasterCarApiRepository } from '@/app/repositories/api/MasterCarApiRepository'
import { MasterCar } from '@/domain/entities/MasterCar'
import {
  PostMasterCarInterface,
  DeleteMasterCarInterface,
  UpdateMasterCarInterface,
} from '@/data/payload/contracts/MasterCarRequest'
@injectable()
export class MasterCarPresenter {
  private repository: MasterCarApiRepository

  constructor(repository: MasterCarApiRepository) {
    this.repository = repository
  }

  public loadMasterCar(params: Object): Promise<MasterCar> {
    return this.repository.getAll(params)
  }

  public postMasterCar(payload: PostMasterCarInterface): Promise<MasterCar> {
    return this.repository.post(payload)
  }

  public updateMasterCar(
    payload: UpdateMasterCarInterface,
    id: number
  ): Promise<MasterCar> {
    return this.repository.update(payload, id)
  }

  public deleteMasterCar(
    payload: DeleteMasterCarInterface
  ): Promise<MasterCar> {
    return this.repository.delete(payload)
  }
}
